import airports from '@/data/airports/airports.json';

const isDomestic = (airportCode) =>
  airports.find(({ code }) => code === airportCode)?.countryCode === 'AU';

export default isDomestic;
